import { render, staticRenderFns } from "./H5GamesPanel.vue?vue&type=template&id=3f57daf4&scoped=true&"
import script from "./H5GamesPanel.vue?vue&type=script&lang=js&"
export * from "./H5GamesPanel.vue?vue&type=script&lang=js&"
import style0 from "./H5GamesPanel.vue?vue&type=style&index=0&id=3f57daf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57daf4",
  null
  
)

export default component.exports